const documentation = () => {
    let functions = {};
    return (name, params, description) => {
        if (name === undefined) {
            return Object.keys(functions);
        }
        if (name in functions) {
            return functions[name];
        }
        functions[name] = {
            params,
            description
        };
    };
};

export const doc = documentation();
